module.exports = __webpack_public_path__ + "22a4b59414371f532673029dbb2a6a31.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/specialthanks_name.svg
 ** module id = 266
 ** module chunks = 0
 **/